import { http_request } from "../interceptors/httpHandler";

export const vendorAuth = (data) => {
    return http_request("/auth/authenticationController/vendorAuthorization", "POST", data, false);
}

export const adminAuth = (data) => {
    return http_request("/auth/v1/token?grant_type=password", "POST", data, false);
}

export const optVerifcation = (data) => {
    return http_request("/auth/authenticationController/vendorotpVerfication", "POST", data, false);
}
